import { Navigate } from 'react-router-dom';
import { getData } from 'utilities/common';
import { isLoggedIn } from 'utilities/common';

export const PublicRoutes = ({ children }) => {
  // Check if the user is logged in
  let user = isLoggedIn('userData');
  let localUser = getData('login-user-info');
  if (localUser) {
    localUser = JSON.parse(localUser);
  }
  let { isAuthenticated } = user;

  // Honor selected adminsMode from localStorage
  const adminsModeData = getData('adminsMode');
  let selectedAdminMode = adminsModeData ? JSON.parse(adminsModeData) : null;

  const userPermissions = localUser?.permissions || {};

  const getPerms = (mode) => {
    if (mode === 'hemp') return Array.isArray(userPermissions.hempPermissions) ? userPermissions.hempPermissions : [];
    if (mode === 'hyperwolf') return Array.isArray(userPermissions.hwPermissions) ? userPermissions.hwPermissions : [];
    if (mode === 'stilo') return Array.isArray(userPermissions.stiloPermissions) ? userPermissions.stiloPermissions : [];
    if (mode === 'hyperdrive') return Array.isArray(userPermissions.hyperdrivePermissions) ? userPermissions.hyperdrivePermissions : [];

    return [];
  };

  let permissionsArray = getPerms(selectedAdminMode);

  // Auto-fallback if selected mode has no permissions
  if (!permissionsArray || permissionsArray.length === 0) {
    if (Array.isArray(userPermissions.hwPermissions) && userPermissions.hwPermissions.length > 0) {
      selectedAdminMode = 'hyperwolf';
      permissionsArray = userPermissions.hwPermissions;
    } else if (Array.isArray(userPermissions.hempPermissions) && userPermissions.hempPermissions.length > 0) {
      selectedAdminMode = 'hemp';
      permissionsArray = userPermissions.hempPermissions;
    } else if (Array.isArray(userPermissions.stiloPermissions) && userPermissions.stiloPermissions.length > 0) {
      selectedAdminMode = 'stilo';
      permissionsArray = userPermissions.stiloPermissions;
    } else if (Array.isArray(userPermissions.hyperdrivePermissions) && userPermissions.hyperdrivePermissions.length > 0) {
      selectedAdminMode = 'hyperdrive';
      permissionsArray = userPermissions.hyperdrivePermissions;
    }
  }

  let screenToLoad = '/';
  if (Array.isArray(permissionsArray) && permissionsArray.length > 0) {
    const dashboard = permissionsArray.find(s => s.title && String(s.title).toLowerCase().trim() === 'dashboard');
    if (dashboard?.redirectUrl) {
      screenToLoad = dashboard.redirectUrl;
    } else {
      const found = permissionsArray.find(p => p?.redirectUrl);
      if (found && found.redirectUrl) screenToLoad = found.redirectUrl;
    }
  }

  return !isAuthenticated ? children : <Navigate to={screenToLoad} />;

};